import { render, staticRenderFns } from "./Erro404.vue?vue&type=template&id=4ee90193&scoped=true&"
import script from "./Erro404.vue?vue&type=script&lang=js&"
export * from "./Erro404.vue?vue&type=script&lang=js&"
import style0 from "./Erro404.vue?vue&type=style&index=0&id=4ee90193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee90193",
  null
  
)

export default component.exports